/**
 * @typedef { { games: Record<string, { timestamp: number, teams: object, children: Record<string, boolean> }> }} Tournament
 */
